import { render, staticRenderFns } from "./learnMoreModal.vue?vue&type=template&id=38aca7c8&scoped=true&"
import script from "./learnMoreModal.vue?vue&type=script&lang=js&"
export * from "./learnMoreModal.vue?vue&type=script&lang=js&"
import style0 from "./learnMoreModal.vue?vue&type=style&index=0&id=38aca7c8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38aca7c8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/oeze/Documents/grupa/grupa-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('38aca7c8')) {
      api.createRecord('38aca7c8', component.options)
    } else {
      api.reload('38aca7c8', component.options)
    }
    module.hot.accept("./learnMoreModal.vue?vue&type=template&id=38aca7c8&scoped=true&", function () {
      api.rerender('38aca7c8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/ClientDashboard/workspace/prekickoff/payment/learnMoreModal.vue"
export default component.exports